import { useState } from "react";

interface AccordionState {
  [key: string]: boolean;
}

const useAccordion = (initialState: AccordionState = {}) => {
  const [accordionState, setAccordionState] =
    useState<AccordionState>(initialState);

  const toggleAccordion = (key: string) => {
    setAccordionState((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
  };

  const expandAll = () => {
    const newState = Object.keys(accordionState).reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {} as AccordionState);
    setAccordionState(newState);
  };

  const collapseAll = () => {
    const newState = Object.keys(accordionState).reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {} as AccordionState);
    setAccordionState(newState);
  };

  const isAnyExpanded = Object.values(accordionState).some((value) => value);

  return {
    accordionState,
    toggleAccordion,
    expandAll,
    collapseAll,
    isAnyExpanded,
  };
};

export default useAccordion;
